import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { App, Button } from '@myua/kit';
import * as favoriteActions from '../actions';
import { getData } from '../selectors';
import { getAssetLabLogger } from '../../app/logs';
import { Trash } from '@myua/icons/dist/bulk16';

export const ClearFavoritesButton = () => {
  const dispatch = useDispatch();
  const empty = useSelector(getData).total.read.count === 0;
  const assetLabLogger = useSelector(getAssetLabLogger);
  const { modal } = App.useApp();

  return (
    <Button
      title="Remove all"
      className="al-btn-blue-icon"
      disabled={empty}
      onClick={() =>
        modal.confirm({
          content: 'Are you sure you want to remove all assets from favorites?',
          onOk: (close) => {
            dispatch(favoriteActions.clearFavoritesClicked());
            assetLabLogger({ action: 'Favorite', sub_action: 'Clear' });
            close();
          },
          okText: 'Remove all',
          icon: null,
        })
      }
      icon={<Trash />}
    >
      Clear
    </Button>
  );
};
